module.exports = ["AnyERC20","TokenSale"];